<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Tools</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Edit</h5>
      <br />
      <br />
      <b-row>
      <b-col md="4">
        <b-form-group
                  id="fieldset-1"
                  label="Membership Type"
                  class="font-weight-bold"
                  label-for="input-1"
                >
                  <b-form-select
                    v-model="membership_types"
                    name="membership_types"
                    v-validate="'required'"
                    data-vv-as="Membership Type"
                    class="mb-3"
                  >
                    <template v-slot:first>
                      <option value disabled>-- Membership Type --</option>
                    </template>
                    <option value="all_type">All Type</option>
                    <option value="gold">Gold</option>
                    <option value="silver">Silver</option>
                  </b-form-select>
                  <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('membership_types') }}</p>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
                  id="fieldset-1"
                  label="Benefit Type"
                  class="font-weight-bold"
                  label-for="input-1"
                >
                  <b-form-select
                    v-model="items.type"
                    name="benefit_types"
                    v-validate="'required'"
                    data-vv-as="Benefit Type"
                    class="mb-3"
                  >
                    <template v-slot:first>
                      <option value disabled>-- Benefit Type --</option>
                    </template>
                    <option value="Fasilitas foto produk gratis">Fasilitas foto produk gratis</option>
                    <option value="Exclusive welcome kit">Exclusive welcome kit</option>
                    <option value="Menjadi merchant PaxelMarket">Menjadi merchant PaxelMarket</option>
                    <option value="Join events #AntarkanKebaikan">Join events #AntarkanKebaikan</option>
                    <option value="Exclusive video 1 menit gratis">Exclusive video 1 menit gratis</option>
                    <option value="Produk dipost influencer 1x">Produk dipost influencer 1x</option>
                    <option value="Hero khusus untuk bisnismu">Hero khusus untuk bisnismu</option>
                    <option value="Harga spesial peralatan bisnis">Harga spesial peralatan bisnis</option>
                    <option value="Diskon packaging material">Diskon packaging material</option>
                    <option value="Harga spesial bahan baku">Harga spesial bahan baku</option>
                    <option value="Asuransi kesehatan">Asuransi kesehatan</option>
                    <option value="Asisten pribadi khusus">Asisten pribadi khusus</option>
                    <option value="Fasilitas paska bayar">Fasilitas paska bayar</option>
                  </b-form-select>
                  <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('benefit_types') }}</p>
        </b-form-group>
      </b-col>
    </b-row>
      <b-row>
      <b-col>
        <b-form-group
            id="input-group-1"
            class="required"
            label-class="control-label"
            label="Image"
            label-for="input-1"
          ></b-form-group>
        <b-card class="text-center bg-gray-100" style="border-style: dashed;">
          <b-row v-if="veeErrors.first('image')" class="m-lg-1" style="background-color: #FEE8E9; border: 1px solid #ffc4c6; border-radius: 5px;">
            <b-col md="12" id="img-error-report">
              <div style="width: 0%; text-align: center; vertical-align: middle; text-align:center;">
                <img src="@/assets/ic-warning-red.svg" class="ic_warning" style="width:25px; position:absolute; margin:auto; top:0; bottom:0;">
              </div>
              <div style="width: 97%; padding-left: 3%;">
                <ul class="text-left" style="margin: 7px 0px;">
                  <li class="text-danger" v-for="imageErr in veeErrors.collect('image')" :key="imageErr"><span class="text-dark">{{ imageErr }}</span></li>
                </ul>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img v-show="!file" v-if="items.image_url" width="100%" :src="items.image_url" />
              <img v-show="file" v-if="url" width="100%" :src="url" />
            </b-col>
          </b-row>
          <input
            type="file"
            ref="file"
            style="display: none"
            name="image"
            v-validate="'minimalDimensions:1000,500|ratiolDimensions:2,1|size:2000|ext:jpg,png,gif,jpeg'"
            @change="onChangeFileUpload()"
          />
          <br />
          <b-link
            @click="$refs.file.click()"
            v-show="!file && !items.image_url"
            variant="primary"
            class="text-primary btn"
          >
            <img class="mr-2" src="@/assets/ic-plus.svg" alt /> Select Image Here
            <label class="text-danger">*</label>
          </b-link>
          <b-button @click="$refs.file.click()" v-show="file || items.image_url" variant="outline-primary" class>
            <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
          </b-button>
          <br />
          <!-- <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p> -->
          <p
            class="text-gray-500"
          >Attach an image (the file must be at least 1000x500 pixels and maximum 2MB. Image must be in JPEG, PNG, or GIF format)</p>
          
        </b-card>
        <br>
        
        <br />
        <label class="text-danger">
          *
          <b class="text-dark">Required</b>
        </label>
      </b-col>

      <b-col md="8">
        <b-row>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title Bahasa"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="'required'"
                name="title_id"
                data-vv-as="Title Bahasa"
                v-model="items.titles.id"
                placeholder="Title Bahasa"
              />
              <b-form-invalid-feedback
                id="input-title_id-feedback"
              >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title English"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="'required'"
                name="title_en"
                data-vv-as="Title English"
                v-model="items.titles.en"
                placeholder="Title English"
              />
              <b-form-invalid-feedback
                id="input-title_en-feedback"
              >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Content Bahasa"
              label-for="input-1"
            >
              <summer-note v-model="items.contents.id" name="content_id_news" placeholder="Content Bahasa"></summer-note>
              <input type="hidden" v-model="items.contents.id" v-validate="'required'" name="content_id" data-vv-as="Content Bahasa">
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('content_id') }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Content English"
              label-for="input-1"
            >
              <summer-note v-model="items.contents.en" name="content_en_news" placeholder="Content English"></summer-note>
              <input type="hidden" v-model="items.contents.en" v-validate="'required'" name="content_en" data-vv-as="Content English">
              <p
                class="text-danger"
                style="width:100%;margin-top:.25rem;font-size: 80%;"
              >{{ veeErrors.first('content_en') }}</p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="fieldset-1" label="Valid Until" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="20px" alt class />
                </b-col>
                <b-col class="px-0">
                  <vc-date-picker v-model="items.valid_until" :min-date="new Date()" mode="dateTime" color="purple" is24hr>
                    <template v-slot="{ inputValue, inputEvents }">
                      <input
                        class="form-control text-dark pl-0 bg-gray calender-select border-left-0"
                        v-validate="'required'"
                        name="period_start"
                        data-vv-as="Event Date & Time"
                        :value="inputValue"
                        v-on="inputEvents"
                      />
                    </template>
                  </vc-date-picker>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <!-- <b-col>
            <b-form-group id="fieldset-1" label="End Date" label-for="input-1">
              <b-row class="m-0">
                <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                  <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                </b-col>
                <b-col class="px-0">
                  <datepicker
                    input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                    placeholder="Select Date"
                    v-model="period_end"
                    :format="customFormatter"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </b-col>
                <b-col align="left" md="1" class="px-0">
                  <b-col
                    align="left"
                    class="pt-1 px-4 form-control del-calender-select border-left-0"
                    md="2"
                  >
                    <b-row align="left" class="pt-1">
                      <b-col>
                        <b-link @click="resetEnddate" style="text-decoration:none">
                          <i class="text-danger fas fa-times"></i>
                        </b-link>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-col>
              </b-row>
              <br />
              <b-row>
              </b-row>
            </b-form-group>
          </b-col> -->
        </b-row>
        <!-- <b-row>
          <b-col>
            <b-form-checkbox
              id="is_highlight"
              v-model="is_highlight"
              name="is_highlight"
              value="true"
              unchecked-value="false"
              :disabled="counthighlight.total > 5"
            >Set as a Highlight Article ({{counthighlight.total}}/5)</b-form-checkbox>
          </b-col>
        </b-row> -->
        <br />
        <b-row class="text-right mt-2">
          <b-col>
            <b-button variant="primary" @click="post()" :disabled="loading" class="mr-5">Update</b-button>
            <router-link :to="{name: 'PointSales'}">
              <b-button variant="outline-secondary">Cancel</b-button>
            </router-link>
          </b-col>
        </b-row>
        <b-modal v-model="modalShow" title="Preview Image" size="xl">
          <img v-if="url" width height="400px" :src="url" />
        </b-modal>
      </b-col>
    </b-row>
    </b-card>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import summerNote from "@/components/Summernote.vue";

export default {
  components: {
    Datepicker,
    summerNote
  },
  data() {
    return {
      isHiddenBahasa: false,
      isHiddenEnglish: false,
      loading: false,
      benefit_types: "",
      membership_types: "",
      selected: "first",
      checked: false,
      modalShow: false,
      file_webp: "",
      widthImage_webp: null,
      heightImage_webp: null,
      url_webp: "",
      items:"",
      file: "",
      widthImage: null,
      heightImage: null,
      InputImage: false,
      url: "",
      image_alt: "",
      title_id: "",
      title_en: "",
      content_id: "",
      content_en: "",
      pic: "",
      no_contact: "",
      url_link: "",
      period_start: "",
      period_end: "",
      is_always_active: false,
      is_highlight: false,
      counthighlight: '',
      options: [],
      tag: "",
      tags: [],
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      }
    };
  },
  beforeMount() {
    this.items = this.$route.params.id
    if (this.items && typeof this.items.valid_until == "string") {
      this.items.valid_until = moment(this.items.valid_until, "DD-MM-YYYY HH:mm").toDate();
    }
    if (this.items.membership_types.length > 1){
        this.membership_types = "all_type"
    } else{
      this.membership_types = this.items.membership_types[0]
    }
  },
  computed: {
    membership(){
      if (this.items.membership_types.length > 1){
        return "all_type"
      } else{
        return this.items.membership_types[0]
      }
    }
  },
  methods: {
    resetStardate() {
      this.period_start = "";
    },
    resetEnddate() {
      this.period_end = "";
    },
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const formData = new FormData();
          console.log(this.items.type);
          formData.append("benefit_type", this.items.type);
          formData.append("titles_en", this.items.titles.en);
          formData.append("titles_id", this.items.titles.id);
          formData.append("contents_en", this.items.contents.en);
          formData.append("contents_id", this.items.contents.id);
          formData.append("image_url", this.file);
          formData.append("existing_image_url", this.items.image_url);
          formData.append(
            "valid_until",
            moment(this.items.valid_until).format("YYYY-MM-DDTHH:mm")
          );
          
          if (this.membership_types == "all_type") {
            formData.append("membership_types", "gold");
            formData.append("membership_types", "silver");
          } else {
            formData.append("membership_types", this.membership_types);
          }

          this.loading = true;
          const payload = {
            id:this.items.id,
            data:formData
          }
          this.$store
            .dispatch("PointSalesModule/putTools", payload)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "PointSales" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500
              });
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.url = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileWebp() {
      this.file_webp = this.$refs.file_webp.files[0];
      const input = this.$refs.file_webp;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage_webp = img.width;
            this.heightImage_webp = img.height;
          };
          img.src = e.target.result;
          this.url_webp = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style scoped>
</style>
